import { Flex, Group } from '@mantine/core';
import { Text } from '@repo/foundations';
import { useStyles } from '../styles';

export function PolicyColumnTableHeader() {
	const { classes } = useStyles();
	return (
		<Group className={classes.columnHeader}>
			<Flex className={classes.columnColumn} p="xs" pl="xl">
				<Text color="text/secondary/default" fw="500" size="xs">
					Column
				</Text>
			</Flex>
			<Flex className={classes.piiColumn} p="xs">
				<Text color="text/secondary/default" fw="500" size="xs">
					PII issue
				</Text>
			</Flex>
			<Flex className={classes.sampleDataColumn} p="xs">
				<Text color="text/secondary/default" fw="500" size="xs">
					Sample data
				</Text>
			</Flex>
			<Flex className={classes.statusColumn} p="xs">
				<Text color="text/secondary/default" fw="500" size="xs">
					Issue status
				</Text>
			</Flex>
			<Flex className={classes.dateColumn} p="xs">
				<Text color="text/secondary/default" fw="500" size="xs">
					Last issue occurred
				</Text>
			</Flex>
		</Group>
	);
}
